import { render, staticRenderFns } from "./editDraw.vue?vue&type=template&id=66e6f672&scoped=true&"
import script from "./editDraw.vue?vue&type=script&lang=js&"
export * from "./editDraw.vue?vue&type=script&lang=js&"
import style0 from "./editDraw.vue?vue&type=style&index=0&id=66e6f672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6f672",
  null
  
)

export default component.exports